import script from "./SetCopywriting.vue?vue&type=script&setup=true&lang=js"
export * from "./SetCopywriting.vue?vue&type=script&setup=true&lang=js"

import "./SetCopywriting.vue?vue&type=style&index=0&id=24aadbc0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24aadbc0"]])

export default __exports__